import { apiClient } from '@/services/api';

const STORAGE_KEY_PREFIX = 'analytics:lastSent:';

function setSent(key) {
  try { localStorage.setItem(STORAGE_KEY_PREFIX + key, String(Date.now())); } catch (_) {}
}

function wasSent(key, ttlMs = 24 * 60 * 60 * 1000) {
  try {
    const v = Number(localStorage.getItem(STORAGE_KEY_PREFIX + key) || '0');
    if (!v) return false;
    return Date.now() - v < ttlMs;
  } catch (_) {
    return false;
  }
}

export async function track(name, props = {}) {
  try {
    await apiClient.post('/analytics/event', { name, props });
  } catch (_) {}
}

export async function trackOnce(key, name, props = {}, ttlMs) {
  if (wasSent(key, ttlMs)) return;
  await track(name, props);
  setSent(key);
}

export default { track, trackOnce };
